import styled from 'styled-components';

type ModeTypes = 'default' | 'error' | 'warning' | 'success';

const modeColors = {
  error: '#FA5245',
  warning: '#CB7813',
  success: '#007B88',
  default: '#d9d9d9',
};

export const Wrapper = styled.div<{
  mode?: ModeTypes;
}>`
  background: #fff;
  padding: 24px;
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
  border-radius: 4px;
  margin-bottom: 12px;
  border: 1px solid #d9d9d9;
  ${(p) =>
    p.mode &&
    ['error', 'warning', 'success'].includes(p.mode) &&
    `
  border-color: ${modeColors[p.mode]}};
  ${Heading} {
    color: ${modeColors[p.mode]}};
  }

  svg {
    path {
      fill: ${modeColors[p.mode]}};
    }
  }
  `}
`;

export const HeadingContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

export const Heading = styled.h3`
  font-weight: 600;
  font-size: 16px;
  line-height: 26px;
  color: #3a4451;
  margin: 0;
  font-family: var(--secondary-font);
`;

export const Message = styled.p`
  font-size: 14px;
  line-height: 20px;
  color: #607187;
  margin: 0;
`;
